import { useEffect } from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { useAuth } from 'src/features/auth/hooks'
import { MemberRole } from 'src/features/member/types'

const useMonitoring = () => {
  const { state, account } = useAuth()

  useEffect(() => {
    if (state === 'Challenging') return

    // Google Analyticsの設定
    if (!!window.dataLayer) {
      window.dataLayer.push({
        logged_in: !!account,
        user_id: !!account ? account.uid : null,
      })
    }

    // Datadog RUMのユーザー設定
    const currentDDUser = datadogRum.getUser()
    if (account && !currentDDUser.id) {
      const hasSelectedTrial = account.hasSelectedTrial
      setDatadogRUMUser({
        id: account.uid,
        userUid: account.uid,
        trialUid: hasSelectedTrial ? account.selectedTrial.uid : undefined,
        trialName: hasSelectedTrial ? account.selectedTrial.name : undefined,
        trialHospitalUid:
          hasSelectedTrial && account.selectedTrialHospitalUid
            ? account.selectedTrialHospitalUid
            : undefined,
        trialHospitalRole:
          hasSelectedTrial && account.selectedTrialHospitalRole
            ? account.selectedTrialHospitalRole
            : undefined,
        trialMemberUid: hasSelectedTrial ? account.member.uid : undefined,
        role: hasSelectedTrial ? account.member.role : undefined,
      })
    } else if (!account && !!currentDDUser.id) {
      datadogRum.clearUser()
    }
  }, [account, state])
}

// Datadog RUMのユーザー設定
// どういう値が入るかを型として制御するためのWrapper
export const setDatadogRUMUser = (userParams: {
  id?: string // UserUIDがTrialPatientUIDが入る
  trialUid?: string
  role?: MemberRole | 'Patient'
  userUid?: string
  trialName?: string
  trialHospitalUid?: string
  trialHospitalRole?: 'Main' | 'Partner'
  trialMemberUid?: string
  trialPatientUid?: string
  patientVideoCallUid?: string
}) => {
  datadogRum.setUser(userParams)
}

export const MonitoringProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useMonitoring()

  return <>{children}</>
}
